import React from 'react';
import { useParams } from 'react-router-dom';
import ReportBuilder from '@/components/ReportBuilder';

const ReportEditor: React.FC = () => {
  const { reportId } = useParams<{ reportId: string }>();

  if (!reportId) {
    return <div>Report ID not found</div>;
  }

  // No outer min-h-screen wrapper — `<main className="iw-main">` already
  // owns the scroll viewport. Stacking another 100vh container inside it
  // forced the parent scroll plus shifted layout when the inner scrollbar
  // appeared.
  return <ReportBuilder reportId={reportId} />;
};

export default ReportEditor;
